export default {
    simpleHeart: {
        gaugeSymbol: {
            empty: '♡',
            fill: '🖤',
            colorBase: '❤︎'
        }
    },
    simpleStar: {
        gaugeSymbol: {
            empty: '☆',
            fill: '★',
            colorBase: '★'
        }
    },
    simpleSymbols: {},
    simple: function() {
        return this.simpleSymbols;
    },
    setSimpleSymbols: function(type) {
        if (type === 'star') {
            this.simpleSymbols = this.simpleStar;
        }
        if (type === 'heart') {
            this.simpleSymbols = this.simpleHeart;
        }
    }
}